export default __webpack_public_path__ + "static/media/bike-hire.ccf1bae2.svg";